import { Country, CountryValidaorByCode } from '@interfaces/country';
import { ColumnStatus, Status } from '@interfaces/table';

export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[a-zA-Z\d@$!%*?&]{6,}$/;
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export enum LOCALSTORAGE {
  USER = 'user',
  TOKEN = 'token',
  IS_PASSWORD_CHANGED = 'isPasswordChanged',
}

export const COUNTRIES: Country[] = [
  {
    label: 'Bangladesh',
    code: '+880',
    mask: '1999999999',
    flag: 'bangladesh',
    validator: {
      regex: /^1[3-9]\d{8}$/,
      message: 'Mobile number must start with 13–19 and be followed by 8 digits',
    },
  },
  // {
  //   label: 'India',
  //   code: '+91',
  //   mask: '9999999999',
  //   flag: 'india',
  //   validator: {
  //     regex: /^[6-9]\d{9}$/,
  //     message: 'Mobile number must start with 6–9 and be followed by 9 digits',
  //   },
  // },
];

export const COUNTRY_VALIDATORS_BY_CODE: CountryValidaorByCode = COUNTRIES.reduce((acc, curr) => {
  acc[curr.code] = curr;
  return acc;
}, {} as CountryValidaorByCode);

export const DEFAULT_SELECTED_COUTNRY = '+880';

export const DEFAULT_ROUTE = '/dashboard';

export const MODAL_CLASSES = 'w-full max-w-sm sm:max-w-lg mx-4 sm:mx-auto';

export const PAYMENT_STATUS_LIST: ColumnStatus = {
  personal: Status.PINK,
  agent: Status.BLUE,
  merchant: Status.SUCCESS,
  'N/A': Status.GRAY,
};
